/* eslint-disable @next/next/no-img-element */

import { Col, Grid, Row } from 'antd';
import CardC from 'src/components/Card';
import ImageC from 'src/components/Image';
import textConstant from 'src/constants/textFasilitasKesehatan';
import FormFasilitasKesehatan from 'src/containers/Forms/FasilitasKesehatan';

import classes from './index.module.css';
import cn from "src/utils/cn";

const PageContainerFasilitasKesehatan = () => {
	const { xs } = Grid.useBreakpoint();
	return (
		<div className={classes['container-page']}>
			<div className="container">
				<Row gutter={32}>
					<Col className={cn({ 'p-0': xs })} lg={10} md={24} sm={24} xs={24}>
						<CardC>
							<div className={classes['form-greeting']}>
								<h3>{textConstant.FASILITAS_KESEHATAN.PAGE_GREETING}</h3>
								<p>{textConstant.FASILITAS_KESEHATAN.PAGE_GREETING_DESC}</p>
							</div>
							<FormFasilitasKesehatan />
						</CardC>
					</Col>
					<Col lg={14} md={24} sm={24} xs={24}>
						<div className={classes['image-content']}>
							<ImageC
								alt="Icon Fasilitas Kesehatan"
								src="/images/fasilitas_kesehatan/fasilitas-kesehatan.svg"
								style={{ objectFit: 'contain' }}
								layout="fill"
							/>
						</div>
					</Col>
				</Row>
			</div>
		</div>
	);
};

export default PageContainerFasilitasKesehatan;
